import React, {Fragment, useContext, useState} from 'react';
import {
  Button,
  Grid,
  IconButton,
  List, ListItem, ListItemSecondaryAction, ListItemText,
  Typography
} from '@material-ui/core';
import {makeStyles, Theme} from '@material-ui/core/styles';
import {Edit} from '@material-ui/icons';

import {AuthContext} from '../../contexts';
import useListFromFirestoreService
  from '../../helpers/useListFromFirestoreService';
import {PicklistItem} from '../../models';

import {BeerTypeEdit, BeerTypeView} from './index';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginTop: theme.spacing(3)
  },
}));


const BeerTypesList = () => {
  console.log("Refreshing BeerTypesList");

  const classes = useStyles();

  const [_beerTypeId, setBeerTypeId] = useState<string|null>(null);
  const [_editing, setEditing] = useState<boolean>(false);
  const [_selectedIndex, setSelectedIndex] = useState<number|null>(null);

  const {itemLists} = useListFromFirestoreService(
      'beerLists', ['beerTypes'], false);

  const {currentUserRoles} = useContext(AuthContext);
  const canContribute = currentUserRoles?.canContribute;

  const handleAdd = () => {
    setBeerTypeId(null);
    setSelectedIndex(null);
    setEditing(true);
  };

  const handleDoneEditing = () => {
    setEditing(false);
    setSelectedIndex(null);
  };

  const handleEdit = (beerType: PicklistItem) => {
    if (beerType.id) {
      setBeerTypeId(beerType.id);
      setEditing(true);
    }
  };

  const handleSelect = (beerType: PicklistItem, index: number) => {
    setSelectedIndex(index);
    setEditing(false);
    beerType.id && setBeerTypeId(beerType.id);
  };

  return (
    <Grid container>
      <Grid item xs={6}>
        <Typography className={classes.title} variant="h2">
          Beer Types
        </Typography>
        {canContribute &&
          <Button
            size="small"
            color="primary"
            onClick={handleAdd}
          >
            Add
          </Button>
        }
        <List className={classes.root} dense>
          {itemLists.beerTypes && itemLists.beerTypes.map((beerType, i) => (
          <Fragment key={i}>
            <ListItem
              divider
              selected={_selectedIndex === i}
              onClick={() => handleSelect(beerType, i)}
            >
              <ListItemText
                primary={beerType.name}
              />
              {canContribute &&
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    onClick={() => handleEdit(beerType)}
                  >
                    <Edit/>
                  </IconButton>
                </ListItemSecondaryAction>
              }
            </ListItem>
          </Fragment>
          ))}
        </List>
      </Grid>
      <Grid item xs={6}>
        {_editing
            ? <BeerTypeEdit id={_beerTypeId} onComplete={handleDoneEditing}/>
            : <BeerTypeView id={_beerTypeId}/>
        }
      </Grid>
    </Grid>
  );
};

export default BeerTypesList;
